exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.dataTable tbody td[data-v-ecfdf62c] {\n  word-break: break-word; word-break: break-all; white-space: normal;\n}\n", ""]);

// exports
